import PropTypes from 'prop-types';
import { TypeAnimation } from 'react-type-animation';

export default function SpeechBubble({ who, text, children }) {
	const classes = ['blog-feedback__speech-bubble'];

	return (
		<div className={classes.join(' ')}>
			{who && <p className="blog-feedback__who">{who}</p>}
			{text && (
				<p className="blog-feedback__text h6">
					<TypeAnimation key={text} sequence={[text]} speed={40} cursor={false} />
				</p>
			)}
			{children}
		</div>
	);
}

SpeechBubble.propTypes = {
	who: PropTypes.string,
	text: PropTypes.string,
	children: PropTypes.node,
};
